import { Role } from '@/modules/adminUsers/roles'

export const accountManagers: Role[] = [
  Role.SuperAdmin,
  Role.BuilderOwner,
  Role.BuilderManager,
]

export const owners: Role[] = [Role.BuilderOwner, Role.SuperAdmin]
